module.exports = __webpack_public_path__ + "img/chpc_index.map.8192994b.png";